<template>
	<header
		:class="{
			'header-shadow': $route.name !== 'evento',
			'header-event': $route.name === 'evento',
			'header-white': $route.meta.whiteBg
		}"
	>
		<!-- <div class="container-fluid header-content"> -->
		<div class="container header-content">
			<div class="mobile-nav" @click.prevent="$store.dispatch('setMenuNavOpened', true)">
				<div class="user-menu">
					<i class="bx bx-menu"></i>
				</div>
			</div>
			<router-link :to="{ name: 'home' }" class="mobile-brand">
				<img v-if="!$route.meta.whiteBg" src="../../assets/logos/mate/lineup-white.svg" alt="LineUp Tickets">
				<img v-else src="../../assets/logos/mate/lineup-black.svg" alt="LineUp Tickets">
			</router-link>
			<router-link :to="{ name: 'login' }" class="mobile-user" v-if="!loggedIn && $route.name !== 'evento-checkout'">
				<div class="user-menu">
					<i class='bx bx-user'></i>
				</div>
			</router-link>
			<div class="mobile-user" @click.prevent="$store.dispatch('setMenuUserOpened', true)" v-if="loggedIn">
				<div class="user-menu">
					<span class="inicial">{{ user.UsuarioPersonaInicial }}</span>
				</div>
			</div>
			<nav class="header-left">
				<router-link :to="{ name: 'home' }" class="item-brand">
					<img v-if="!$route.meta.whiteBg" src="../../assets/logos/mate/lineup-white.svg" alt="LineUp Tickets">
					<img v-else src="../../assets/logos/mate/lineup-black.svg" alt="LineUp Tickets">
				</router-link>
				<div class="search-box" v-if="$route.name !== 'home'" @click.prevent="$store.dispatch('showIsSearching')">
					<i class='search-icon bx bx-search'></i>
					<span class="search-placeholder">Busca por evento, artista, equipo, ciudad, competición</span>
				</div>
				<router-link :to="{ name: 'home' }" class="item" active-class="active" exact>
					<span>Inicio</span>
				</router-link>
				<router-link
					:to="{ name: 'eventos' }"
					class="item"
					active-class="active"
					exact
				>
					<span>Eventos</span>
				</router-link>
				<router-link
					:to="{ name: 'contacto' }"
					class="item"
					active-class="active"
					exact
				>
					<span>Contacto</span>
				</router-link>
				<router-link
					:to="{ name: 'mis-tickets' }"
					class="item"
					active-class="active"
					exact
					v-if="loggedIn"
				>
					<span>Mis Tickets</span>
				</router-link>
			</nav>
			<div class="header-right">
				<div class="login-button" v-if="!loggedIn && $route.name !== 'evento-checkout'" @click.prevent="logIn()">
					<span>Entrar</span>
				</div>
				<div v-if="!loggedIn && $route.name !== 'evento-checkout'" class="register-button" @click.prevent="register()">
					<span>Registrarse</span>
				</div>
				<div class="user-menu" @click.prevent="showDropdown = !showDropdown" v-click-outside="hideDropdown" v-if="loggedIn">
					<i class="bx bx-menu"></i>
					<span>{{ userFirstName }}</span>
				</div>
				<transition name="scale" mode="out-in">
					<div v-if="showDropdown" class="dropdown">
						<router-link :to="{ name: 'informacion-personal' }" class="item-usuario">
							<i class='bx bx-user'></i>
							<span>Cuenta</span>
						</router-link>
						<router-link :to="{ name: 'mis-tickets' }" class="item-usuario">
							<i class='bx bx-qr' ></i>
							<span>Mis tickets</span>
						</router-link>
						<div class="item-divider" v-if="loggedIn && (user.IsOrganizador === true || user.IsOrganizador === 'true')"></div>
						<router-link :to="{ name: 'organizador-dashboard' }" class="item-usuario" v-if="loggedIn && (user.IsOrganizador === true || user.IsOrganizador === 'true')">
							<i class='bx bx-trending-up'></i>
							<span>Panel de organizador</span>
						</router-link>
						<div class="item-divider"></div>
						<a href="" @click.prevent="logOutAction" class="item-usuario">
							<span>Cerrar sesión</span>
						</a>
					</div>
				</transition>
			</div>
		</div>

		<div class="mobile-aside mobile-menu-nav" :class="isMenuNavOpened ? 'visible' : ''">
			<div class="mobile-menu-top">
				<div class="search-box" @click.prevent="$store.dispatch('showIsSearching')">
					<i class='search-icon bx bx-search'></i>
					<span class="search-placeholder">Buscar eventos</span>
				</div>
				<div class="mobile-menu-top-right" @click.prevent="$store.dispatch('setMenuNavOpened', false)">
					<i class='bx bx-x'></i>
				</div>
			</div>
			<nav>
				<router-link :to="{ name: 'home' }" class="item" active-class="active" exact>
					<span>Inicio</span>
				</router-link>
				<router-link
					:to="{ name: 'eventos' }"
					class="item"
					active-class="active"
					exact
				>
					<span>Eventos</span>
				</router-link>
				<router-link
					:to="{ name: 'contacto' }"
					class="item"
					active-class="active"
					exact
				>
					<span>Contacto</span>
				</router-link>
				<router-link
					:to="{ name: 'mis-tickets' }"
					class="item"
					active-class="active"
					exact
					v-if="loggedIn"
				>
					<span>Mis Tickets</span>
				</router-link>
			</nav>
		</div>
		
		<div class="mobile-aside mobile-menu-user" :class="isMenuUserOpened ? 'visible' : ''">
			<div class="mobile-menu-top">
				<div class="search-box" @click.prevent="$store.dispatch('showIsSearching')">
					<i class='search-icon bx bx-search'></i>
					<span class="search-placeholder">Buscar eventos</span>
				</div>
				<div class="mobile-menu-top-right" @click.prevent="$store.dispatch('setMenuUserOpened', false)">
					<i class='bx bx-x'></i>
				</div>
			</div>
			<nav>
				<router-link :to="{ name: 'informacion-personal' }" class="item">
					<i class='bx bx-user'></i>
					<span>Cuenta</span>
				</router-link>
				<router-link :to="{ name: 'mis-tickets' }" class="item">
					<i class='bx bx-qr' ></i>
					<span>Mis tickets</span>
				</router-link>
				<div class="item-divider" v-if="loggedIn && (user.IsOrganizador === true || user.IsOrganizador === 'true')"></div>
				<router-link :to="{ name: 'organizador-dashboard' }" class="item" v-if="loggedIn && (user.IsOrganizador === true || user.IsOrganizador === 'true')">
					<i class='bx bx-trending-up'></i>
					<span>Panel de organizador</span>
				</router-link>
				<div class="item-divider"></div>
				<a href="" @click.prevent="logOutAction" class="item">
					<span>Cerrar sesión</span>
				</a>
			</nav>
		</div>
	</header>
</template>

<script>
	import { mapState, mapActions, mapGetters } from "vuex";

	export default {
		data() {
			return {
				showDropdown: false,
				showUserMobile: false
			};
		},
		computed: {
			...mapState("AuthModule", ["loggedIn", "user"]),
			...mapGetters("AuthModule", ["userFirstName"]),
			...mapGetters(['isMenuNavOpened', 'isMenuUserOpened'])
		},
		watch: {
			'$route' () {
				this.$store.dispatch('setMenuNavOpened', false)
				this.$store.dispatch('setMenuUserOpened', false)
			}
		},
		methods: {
			...mapActions("AuthModule", ["logout"]),

			logIn() {
				this.$store.dispatch("AuthModule/showAuthModal", {
					callbackAction: {
						name: "AuthModule/redirigirA",
						payload: {
							// route: "home",
							route: this.$route.name,
							params: {},
						},
					},
				});
			},
			register() {
				this.$store.dispatch("AuthModule/updateCallbackAction", {
					callbackAction: {
						name: "AuthModule/redirigirA",
						payload: {
							// route: "home",
							route: this.$route.name,
							params: {},
						},
					},
				});

				this.$router.push({ name: "register" });
			},
			hideDropdown() {
				this.showDropdown = false;
			},
			logOutAction() {
				this.hideDropdown();
				this.logout();
			}
		},
	};
</script>

<style lang="scss" scoped>
	header {
		top: 0;
		position: sticky;
		width: 100%;
		z-index: 10;
		height: var(--height-header);
		// background-color: rgba(31, 31, 31, 0.8);
		background-color: var(--color-secondary-opacity);
		border-bottom: 1px solid var(--color-secondary-border);
		box-shadow: none;
		-webkit-backdrop-filter: saturate(150%) blur(24px);
		backdrop-filter: saturate(150%) blur(24px);
		@include transition(all 0.15s);
		@include flex(row, space-between, center);

		&.header-shadow {
			.header-content {
				nav {
					.item-brand {
						img {
							height: 38px;
						}
					}
				}
			}
		}

		&.header-event {
			background-color: transparent;
			margin-bottom: -88px;
			height: 88px;
			position: relative;
			-webkit-backdrop-filter: none;
			backdrop-filter: none;
			border-bottom: 1px solid rgba(255, 255, 255, 0.16);
		}

		&.header-white{
			background-color: var(--color-white);
			border-bottom: 1px solid #ebebeb;

			.header-content{
				nav{
					.search-box{
						border: 1px solid #DDDDDD;
						box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 4px 12px rgba(0,0,0,0.05);
						background-color: var(--color-white);

						&:hover {
							box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
						}

						i{
							color: #717171;
						}
						
						.search-placeholder{
							color: #717171;
						}
						
					}

					.item{
						span{
							color: var(--color-darker);
						}
					}
				}

				.header-right{
					.login-button{
						color: var(--color-darker);
						border: 1px solid #b0b0b0;
					}

					.register-button{
						background-color: var(--color-darker);
						color: var(--color-white);
					}

					.user-menu{
						border-color: #DDDDDD;
						border-width: 1px;

						span{
							color: var(--color-darker);
						}

						i{
							color: var(--color-darker);
						}

						&:hover{
							border-color: #DDDDDD;
						}
					}
				}

				.mobile-user, .mobile-nav{
					color: var(--color-darker);

					.user-menu{
						border: 2px solid rgba(0, 0, 0, 0.16);

						i{
							color: var(--color-darker);
						}

						.inicial{
							color: var(--color-darker);
						}
					}
				}
			}
		}

		.mobile-aside{
			position: absolute;
			width: 0px;
			height: 100vh;
			background-color: var(--color-white);
			top: 0;
			left: 0;
			overflow: hidden;
			transition: all 0.3s ease-in-out;
			@include flex(column, flex-start, flex-start);
			
			&.visible{
				transform: translateX(0%);
				width: 100vw;
			}

			.mobile-menu-top{
				width: 100%;
				@include flex(row, space-between, center);
				border-bottom: 1px solid rgba(0, 0, 0, 0.16);
				padding: 0 20px;
				height: var(--height-header);

				.search-box{
					@include flex(row, flex-start, center);
					width: calc(100% - 60px);
					border-radius: 99px;
					padding: 12px 0px;
					background-color: var(--color-white);
					backdrop-filter: blur(25px);
					@include transition(all .2s);
					cursor: pointer;

					i{
						color: #717171;
						line-height: 1em;
						font-size: 18px;
						margin-right: 10px;
					}
					
					.search-placeholder{
						margin: 0;
						padding: 0;
						font-family: var(--font-inter);
						color: #717171;
						font-weight: var(--fw-400);
						font-size: 14px;
						line-height: 1em;
					}
					
				}

				.mobile-menu-top-right{
					border-radius: 21px !important;
					border: 2px solid rgba(0, 0, 0, 0.16);
					padding: 0px;
					width: 40px;
					height: 40px;
					cursor: pointer;
					@include flex(row, center, center);

					i {
						color: var(--color-darker);
						font-size: 20px;
					}
				}
			}

			nav{
				width: 100%;
				padding: 20px;
				@include flex(column, flex-start, flex-start);

				.item{
					position: relative;
					text-decoration: none;
					@include flex(row, center, center);
					padding: 12px 0px;

					span {
						font-family: var(--font-sora);
						text-transform: uppercase;
						font-size: 14px;
						color: var(--color-darker);
						font-weight: var(--fw-700);
						line-height: 1.3em;
						letter-spacing: 1px;
						@include transition(all 0.5s);

						&:hover {
							@include transition(all 0.5s);
							color: var(--color-primary);
						}
					}

					&.active {
						span {
							font-weight: var(--fw-700);
							color: var(--color-primary);
						}
					}

					i{
						color: var(--color-darker);
						text-decoration: none;
						font-size: 19px;
						margin-right: 7px;
					}
				}

				.item-divider{
					height: 1px;
					width: 100%;
					background-color:rgba(0, 0, 0, 0.1);
					margin: 8px 0px;
				}
			}

			// .mobile-ticketin{
			// 	position: absolute;
			// 	width: 45%;
			// 	height: auto;
			// 	bottom: 20px;
			// 	right: 20px;
			// 	opacity: 0.25;
			// }
		}

		.mobile-menu-user{
			right: 0;
			left: unset;
			-webkit-transform: translateX(100%);
			-moz-transform: translateX(100%);
			-ms-transform: translateX(100%);
			-o-transform: translateX(100%);
			transform: translateX(100%);
		}

		.mobile-menu-nav{
			-webkit-transform: translateX(-100%);
			-moz-transform: translateX(-100%);
			-ms-transform: translateX(-100%);
			-o-transform: translateX(-100%);
			transform: translateX(-100%);
		}

		.header-content {
			width: 100%;
			height: 100%;
			@include flex(row, space-between, center);

			nav {
				height: 100%;
				@include flex(row, flex-start, center);

				.item-brand {
					text-decoration: none;
					margin-right: 60px;
					@include flex(row, flex-start, center);

					img {
						height: 40px;
						@include transition(all 0.15s);
					}
				}

				.search-box{
					@include flex(row, flex-start, center);
					margin-right: 30px;
					border-radius: 99px;
					padding: 12px 18px;
					background-color: #151515;
					backdrop-filter: blur(25px);
					@include transition(all .2s);
					cursor: pointer;

					i{
						color: #666666;
						line-height: 1em;
						font-size: 18px;
						margin-right: 10px;
					}
					
					.search-placeholder{
						margin: 0;
						padding: 0;
						font-family: var(--font-inter);
						color: #666666;
						font-weight: var(--fw-400);
						font-size: 14px;
						line-height: 1em;
					}
					
				}

				.item {
					position: relative;
					text-decoration: none;
					@include flex(row, center, center);
					padding: 12px 0px;
					margin-right: 24px;
					height: 100%;

					&:last-child {
						margin-right: 0px;
					}

					span {
						font-family: var(--font-sora);
						text-transform: uppercase;
						font-size: 12px;
						// color: var(--color-darker);
						color: var(--color-white);
						font-weight: var(--fw-700);
						line-height: 1em;
						letter-spacing: 1px;
						@include transition(all 0.5s);

						&:hover {
							@include transition(all 0.5s);
							color: var(--color-primary);
						}
					}

					&.active {
						box-shadow: inset 0 -4px 0 var(--color-primary);
						span {
							font-weight: var(--fw-700);
							color: var(--color-primary);
						}

						// &:before{
						// 	content: '';
						// 	position: absolute;
						// 	width: 100%;
						// 	height: 4px;
						// 	background-color: var(--color-primary);
						// 	border-radius: 99px;
						// 	bottom: -18px;
						// 	left: 50%;
						// 	transform: translateX(-50%);
						// }
					}
				}
			}

			.header-right{
				@include flex(row, flex-end, center);
				position: relative;
			}

			.login-button {
				@include flex(row, center, center);
				text-decoration: none;
				padding: 12px 30px;
				margin-right: 10px;
				font-size: 12px;
				font-family: var(--font-sora);
				color: var(--color-white);
				font-weight: var(--fw-600);
				line-height: 1.3em;
				letter-spacing: 0.5px;
				text-transform: uppercase;
				background-color: transparent;
				border: 1px solid rgba(254,253,251,0.2);
				border-radius: 99px;
				cursor: pointer;
				@include transition(all 0.2s);

				&:hover {
					border-color: var(--color-primary);
					background-color: var(--color-primary);
					color: var(--color-darker);
				}
			}

			.register-button {
				@include flex(row, center, center);
				text-decoration: none;
				padding: 12px 30px;
				font-family: var(--font-sora);
				text-transform: uppercase;
				font-size: 12px;
				color: var(--color-darker);
				background-color: var(--color-primary);
				font-weight: var(--fw-600);
				line-height: 1.3em;
				letter-spacing: 0.5px;
				border-radius: 24px;
				cursor: pointer;
				@include transition(all 0.2s);

				&:hover {
					opacity: 0.9;
				}

				&:focus {
					-webkit-box-shadow: 0 0 0 0.2rem rgba(255, 97, 82, 0.5);
					box-shadow: 0 0 0 0.2rem rgba(255, 97, 82, 0.5);
				}
			}

			.mi-perfil {
				border: 1px solid rgb(176, 176, 176);
				border-radius: 99px;
				padding: 10px 14px;
				text-decoration: none;
				color: var(--color-darker);
				@include flex(row, space-between, center);

				span {
					font-size: 13px;
					font-weight: var(--fw-700);
					font-family: var(--font-sora);
					line-height: 1em;
					letter-spacing: 0.3px;
					// text-transform: uppercase;
				}

				i {
					font-size: 18px;
					margin-right: 4px;
				}
			}

			.user-menu {
				border-radius: 21px !important;
				border: 2px solid #666666;
				padding: 10px 16px;
				cursor: pointer;
				@include transition(all 0.2s);
				@include flex(row, space-between, center);

				i {
					color: var(--color-white);
					font-size: 18px;
					margin-right: 6px;
				}

				span {
					font-size: 13px;
					font-weight: var(--fw-700);
					font-family: var(--font-sora);
					line-height: 1em;
					letter-spacing: 0.3px;
					color: var(--color-white);
				}

				&:hover {
					box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
					border-color: var(--color-white);
				}
			}

			.dropdown {
				position: absolute;
				background: var(--color-white);
				width: 220px;
				border-radius: 10px;
				top: 44px;
				right: 0;
				@include flex(column, flex-start, flex-start);
				padding: 5px 0;
				margin: 0;
				border: 1px solid rgba(0, 0, 0, 0.1);
				box-shadow: rgba(0, 0, 0, 0.12) 0px 6px 16px;

				.item-usuario {
					@include flex(row, flex-start, center);
					padding: 12px 15px;
					cursor: pointer;
					border-radius: 0;
					width: 100%;
					border: none;
					text-decoration: none;
					color: var(--color-darker);

					i {
						font-size: 16px;
						margin-right: 6px;
						line-height: 1em;
					}

					span {
						font-size: 14px;
						line-height: 1em;
						font-weight: var(--fw-500);
					}

					&:hover {
						border: none;
						background: rgba(0, 0, 0, 0.05);
					}
				}

				.item-divider{
					width: 100%;
					margin: 6px 0px;
					height: 1px;
					background-color: rgba(0, 0, 0, 0.05);
				}
			}

			.mobile-nav, .mobile-brand, .mobile-user{
				display: none;
			}

			.mobile-brand{
				img{
					height: 34px;
					@include transition(all 0.15s);
				}
			}

			.mobile-user, .mobile-nav{
				width: 40px;
				overflow: hidden;
				color: var(--color-white);
				text-decoration: none;

				.user-menu{
					padding: 0px;
					width: 40px;
					height: 40px;
					@include flex(row, center, center);

					i{
						margin-right: 0px;
					}

					.inicial{
						color: var(--color-white);
						font-weight: var(--fw-600);
						font-size: 16px;
						line-height: 1em;
						margin-top: 1px;
					}
				}
			}
		}
	}

	@media screen and (max-width: 1264px){
		header{
			.header-content{
				nav{
					.item-brand{
						margin-right: 30px;
					}
					
					.search-box{
						padding: 0px;
						width: 44px;
						height: 44px;
						@include flex(row, center, center);

						i{
							margin-right: 0px;
						}

						.search-placeholder{
							display: none;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 850px){
		header{
			--height-header: 60px;

			.header-content{
				.header-left, .header-right{
					display: none;
				}

				.mobile-nav{
					@include flex(row, flex-start, center);
				}

				.mobile-brand{
					@include flex(row, center, center);
				}

				.mobile-user{
					@include flex(row, flex-end, center);
				}
			}
		}
	}
</style>
